var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),(_vm.isLoading)?_c('div',[_vm._m(0),_c('div',[_vm._v("Loading... ("+_vm._s(_vm.refCount)+")")])]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }